export default __webpack_public_path__ + "static/media/Greek-Blue.7d8d3c08.jpg";